import yup from "../../../../../utils/yup-extended";
import {Alert, Button, message, Select, Space} from "antd";
import {StyledConnectBankAccountBoxWrapper} from "../../connect-bank-account/styles";
import {StyledTransactionSettingsBoxContentWrapper} from "./style";
import {Controller, useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import {
  TransactionChargeSettingsValidApiResponse,
  useFetchTransactionChargeSettings,
  useUpdateTransactionChargeSettings,
} from "../../../../../react-query-hooks/payout";
import {FullPageLoader} from "../../../../full-page-loader";
import {AxiosResponse} from "axios";

export enum ChargeBearer {
  coach = "coach",
  customer = "customer",
}

const TransactionSettingsFormSchema = yup.object({
  charge_bearer: yup
    .string()
    .oneOf(Object.values(ChargeBearer), "Select an option")
    .required(),
});

export type TransactionSettingsFormValuesType = {
  charge_bearer: ChargeBearer;
};

export function TransactionSettingsTabFetchWrapper() {
  const {status, error, data} = useFetchTransactionChargeSettings();
  if (status === "loading") {
    return <FullPageLoader />;
  }

  if (status === "error") {
    return <Alert message="Error" description={error.message} type="error" showIcon />;
  }
  return (
    <div>
      <TransactionSettingsTab data={data} />
    </div>
  );
}

export function TransactionSettingsTab({
  data,
}: {
  data: AxiosResponse<TransactionChargeSettingsValidApiResponse | null, any>;
}) {
  const {mutate, isLoading} = useUpdateTransactionChargeSettings();
  const {
    handleSubmit,
    formState: {errors},
    control,
    watch,
  } = useForm<TransactionSettingsFormValuesType>({
    resolver: yupResolver(TransactionSettingsFormSchema),
    mode: "onChange",
    defaultValues: {
      charge_bearer: data.data ? data.data.charge_bearer : ChargeBearer["coach"],
    },
  });

  const onSubmit = (values: TransactionSettingsFormValuesType) => {
    mutate(
      {
        charge_bearer: values.charge_bearer,
      },
      {
        onSuccess: () => {
          message.success("Updated successfully");
        },
      }
    );
  };

  return (
    <StyledConnectBankAccountBoxWrapper>
      <StyledTransactionSettingsBoxContentWrapper>
        <p className="bold-text">Transaction fee settings</p>
        <form onSubmit={handleSubmit(onSubmit)}>
          <StyledTransactionSettingsBoxContentWrapper>
            <div>
              <Space size={8} style={{display: "flex"}} direction="vertical">
                <p className="info-text">
                  Select who pays the transaction fee.{" "}
                  <a
                    href="https://www.coachli.co/home/pricing"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span className="bold-text underline-text">
                      View transaction fees
                    </span>
                  </a>
                </p>
                <div>
                  <Controller
                    control={control}
                    name="charge_bearer"
                    render={({field: {onChange, value}}) => (
                      <>
                        <Select
                          size="large"
                          // defaultValue="lucy"
                          value={value}
                          style={{width: "100%"}}
                          onChange={(v) => {
                            onChange(v);
                          }}
                          options={[
                            {
                              label: "Charge me",
                              value: "coach",
                            },
                            {
                              label: "Let customers pay",
                              value: "customer",
                            },
                          ]}
                          placeholder="Select an option"
                          status={errors.charge_bearer && "error"}
                        />
                        {errors.charge_bearer?.message && (
                          <div role="alert" className="ant-form-item-explain-error">
                            {errors.charge_bearer?.message}
                          </div>
                        )}
                      </>
                    )}
                  />
                </div>
              </Space>
            </div>
            <div>
              <Button
                size="small"
                htmlType="submit"
                loading={isLoading}
                type="primary"
                disabled={
                  Object.keys(errors).length > 0 || Object.values(watch()).length < 1
                }
              >
                Save changes
              </Button>
            </div>
          </StyledTransactionSettingsBoxContentWrapper>
        </form>
      </StyledTransactionSettingsBoxContentWrapper>
    </StyledConnectBankAccountBoxWrapper>
  );
}
